import { TrunkItemState } from "ducks/trunkItem/type";
export const initialState: TrunkItemState = {
  isLoading: false,
  trunks: [],
  trunkItems: [],
};
